
// These would ideally be stored in environment variables or a secure backend
export const VALID_PASSWORDS = [
  "password123",
  "course2024",
  "learningtime",
  "mccsc"
];

export const validatePassword = (password: string): boolean => {
  return VALID_PASSWORDS.includes(password);
};

export const setAccessToken = () => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 30); // 30 days from now
  
  localStorage.setItem('courseAccess', JSON.stringify({
    granted: true,
    expiry: expiryDate.toISOString()
  }));
};

export const checkAccess = (): boolean => {
  const access = localStorage.getItem('courseAccess');
  if (!access) return false;
  
  try {
    const { granted, expiry } = JSON.parse(access);
    const now = new Date();
    const expiryDate = new Date(expiry);
    
    return granted && now < expiryDate;
  } catch {
    return false;
  }
};

export const clearAccess = () => {
  localStorage.removeItem('courseAccess');
};
